import { Auth } from 'aws-amplify';

import GuestBase from '@/views/Guest/Layout';
// import Login from '@/views/Guest/Login';
// import Register from '@/views/Guest/Register';
// import Forgot from '@/views/Guest/Forgot';
// import ForgotConfirmation from '@/views/Guest/ForgotConfirmation';
// import Activate from '@/views/Guest/Activate';
// import NewPassword from '@/views/Guest/NewPassword';


import SignIn from '@/views/Guest/Auth/SignIn';
import SignUp from '@/views/Guest/Auth/SignUp';
import ConfirmSignUp from '@/views/Guest/Auth/ConfirmSignUp';
import CompleteNewPassword from '@/views/Guest/Auth/CompleteNewPassword';
import ResendSignUp from '@/views/Guest/Auth/ResendSignUp';
import ForgotPasswordSubmit from '@/views/Guest/Auth/ForgotPasswordSubmit';
import ForgotPassword from '@/views/Guest/Auth/ForgotPassword';


function loggedOut(to, from, next) {
  Auth.currentAuthenticatedUser().then(() => {
    next({ name: 'UserBase' });
  }).catch(() => {
    next();
  });
}

export default [
  {
    path: '/',
    name: 'GuestBase',
    component: GuestBase,
    beforeEnter: loggedOut,
    redirect: { name: 'SignIn' },
    children: [
      {
        path: 'signIn',
        name: 'SignIn',
        component: SignIn,
      },
      {
        path: 'signUp',
        name: 'SignUp',
        component: SignUp,
      },
      {
        path: 'confirmSignUp',
        name: 'ConfirmSignUp',
        component: ConfirmSignUp,
      },
      {
        path: 'completeNewPassword',
        name: 'CompleteNewPassword',
        component: CompleteNewPassword,
      },
      {
        path: 'resendSignUp',
        name: 'ResendSignUp',
        component: ResendSignUp,
      },
      {
        path: 'forgotPasswordSubmit',
        name: 'ForgotPasswordSubmit',
        component: ForgotPasswordSubmit,
      },
      {
        path: 'forgotPassword',
        name: 'ForgotPassword',
        component: ForgotPassword,
      },
    ],
  },
];
